import { Autocomplete } from "@mantine/core";
import type { ContactGroup } from "@/shared-types";
import classes from "./NameInput.module.css";

interface NameInputProps {
    value: string;
    onChange: (name: string) => void;
    contacts: ContactGroup[];
}

export function NameInput({ value, onChange, contacts }: NameInputProps) {
    return (
        <Autocomplete
            classNames={{ input: classes.input }}
            value={value}
            data={contacts}
            autoFocus
            onChange={onChange}
            onOptionSubmit={onChange}
            placeholder="Search for an extension"
            clearable
            styles={{
                input: {
                    backgroundColor: "var(--mantine-color-dark-8)",
                },
            }}
            data-testid="name-input-autocomplete"
        />
    );
}
